<template>
  <navbar id="navbar-obj" v-model="showNavbar">
    <div class="navbar-wrapper">
      <div id="sidebar-toggler" class="navbar-custom-toggler navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
    </div>

    <template slot="navbar-menu">
<!--      <form>-->
<!--        <div class="input-group no-border input-round">-->
<!--          <input type="text" value="" class="form-control" :placeholder="$t('Search...')">-->
<!--          <div class="input-group-append">-->
<!--            <div class="input-group-text">-->
<!--              <i class="nc-icon nc-zoom-split"></i>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </form>-->
      <ul class="navbar-nav">
        <notification @clicked="toggleNavbar"/>
        <li class="nav-item">
          <el-tooltip :content="$t('Feedback')" placement="bottom">
            <a class="nav-link btn-magnify" href="#" @click="showFeedbackForm">
              <i class="pt-2 far fa-comment-alt logout-icon"/>
              <p><span class="d-lg-none d-md-block ml-2">Feedback</span></p>
            </a>
          </el-tooltip>
        </li>
        <li class="nav-item">
          <el-tooltip :content="$t('Logout')" placement="bottom">
            <a class="nav-link btn-magnify" href="#" @click="confirmAndLogout">
              <i class="pt-2 fas fa-power-off logout-icon"/>
              <p><span class="d-lg-none d-md-block ml-2">{{ this.$t('Logout')}}</span></p>
            </a>
          </el-tooltip>
        </li>
      </ul>
      <locale-drop-down></locale-drop-down>
    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import { Tooltip } from 'element-ui'
  import Notification from './Notification'
  import LocaleDropDown from '../../UIComponents/LocaleDropDown'

  export default {
    components: {
      [Tooltip.name]: Tooltip,
      Notification,
      LocaleDropDown,
      Navbar,
      NavbarToggleButton
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      toggleNavbar() {
        this.showNavbar = false;
      },
      confirmAndLogout () {
        this.$emit('logout', true)
      },
      showFeedbackForm () {
        this.showNavbar = false
        this.$router.push({ name: 'UserFeedback', params: {} })
      },
      checkMouseEvent(event) {
        if (this.showNavbar === false) return
        var container = document.getElementById('navbar-obj')
        // console.log(event.target.classList)
        if (!container.contains(event.target) || event.target.classList.contains('navbar-toggler-bar') || event.target.classList.contains('navbar-toggler')){
          this.showNavbar = false
        }
      }
    },
    mounted() {
      window.addEventListener('mouseup', this.checkMouseEvent)
    },
    beforeDestroy() {
      window.removeEventListener('mouseup', this.checkMouseEvent)
    }
  }

</script>
<style>
  .logout-icon {
    font-size: 20px !important;
    margin-top: -5px;
  }
</style>
